export default "__VITE_ASSET__9243dbd7__"